// @flow

const ellipsis = (width?: string = '100%') => ({
  display: 'block',
  maxWidth: width,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
})

export default ellipsis



// WEBPACK FOOTER //
// ./src/style/ellipsis.js